const ENPhrases = {
	"a vencer": "to expire",
	"A vencer": "To expire",
	"A vencer em": "To expire in",
	"Acompanhar andamento": "Track progress",
	"Adicionar comentário": "Add comment",
	"Adicionar grupo": "Add group",
	"Adicionar Item": "Add Item",
	"Adicionar resposta à causa": "Add answer to cause",
	"Adicionar usuário": "Add user",
	"Alterado por": "Modified by",
	"Alterar andamento": "Change progress",
	"Alterar para cards": "Change to cards",
	"Alterar para lista": "Change to list",
	"Alterar meta":"Change goal",
	"Adicionar Faixa":"Add range",
	"Agrupador padrão atualizado com sucesso": "Standard grouper successfully updated",
	"Alterar senha" : "Change password",
	"Análises críticas": "Critical analysis",
	"Análises do risco": "Risk analysis",
	"Andamento alterado com sucesso": "Progress changed successfully",
	"Anexo inserido com sucesso": "Attachment successfully inserted",
	"Ano base": "Base year",
	"Ao menos uma permissão deve ser (Visualizar e Editar)": "At least one permission must be (View and Edit)",
	"Ao menos uma permissão deve ser informada":"At least one permission must be informed",
	"Ao restaurar os valores padrões você irá perder todas as configurações atuais, tem certeza?":"If you restore default values you will lose all the actual configuration, you are sure?",
	"Aplicar configurações": "Apply settings",
	"Aplicar filtro": "Apply filter",
	"áreas preenchidas": "filled areas",
	"Arraste e solte alguns arquivos aqui ou clique para selecionar arquivos": "Drag n drop some files here, or click to select files",
	"Aprendizado e Crescimento": "Learning and Growth",
	"Atingiu a meta": "Reached the goal",
	"Ativar o modo de manutenção": "Activate maintenance mode",
	"Ao menos uma faixa deve ser informada":"At least one range must be included",
	"As novas permissões serão aplicadas no próximo login": "New permissions will be applied on next login",
	"As ações vinculadas a FCA também serão excluídas": "FCA linked shares will also be excluded",
	"Autenticação em dois fatores": "Two-factor authentication",
	"Bloquear excedente": "Block overrun",
	"BSC x Indicadores": "BSC x Indicators",
	"Casas decimais":"Decimal places",
	"Cadastros básicos": "Basic records",
	"Cadastros Básicos": "Basic Records",
	"Campos dos Indicadores":"Indicator's fields",
	"Causa é requerida": "Cause is required",
	"Central de ajuda": "Help central",
	"Chave de acesso externo": "External access key", 
	"Chave de acesso externo inválida": "Invalid external access key",
	"Chave Inválida ou inexistente": "Invalid key ou inexistant",
	"Cinco porquês": "Five whys",
	"Código é requerido":"Code is required",
	"Código está repetido":"Code is repeated",
	"Classificação do Indicador": "Indicator Classification",
	"Clique aqui para navegar para a tela de permissões": "Click here to navigate to permissions screen",
	"Comentário é requerido": "Comment is required",
	"Comentário excluído com sucesso": "Comment deleted successfully",
	"Comentário inserido com sucesso": "Comment successfully added",
	"Comprimir todos agrupadores": "Compress all groupers",
	"Configurações do sistema": "System settings",
	"Confirmar alteração": "Submit change",
	"Confirmar senha": "Confirm password",
	"Confirme sua ultima ação antes de atualizar o item":"Confirm your last action before change the item",
	"Confirme sua ultima ação antes de adicionar o item":"Confirm your last action before add the item",
	"Confirme sua ultima ação antes de salvar o item":"Confirm your last action before save the item",
	"Confirme sua ultima ação antes de movimentar o item":"Confirm your last action before move the item",
	"Configurar IP's de acesso": "Configure access IP's",
	"Configurações de sistema": "System settings",
	"Consultados não podem ser repetidos": "Consulteds cannot be repeated",
	"Cor da faixa é requerida":"Range's color is required",
	"Configurações de usuário": "User settings",
	"Cria e edita": "Create and update",
	"Cria, edita e exclui": "Create, update and delete",
	"Criado por": "Created by",
	"Data Inicial": "Initial Date",
	"Data inválida": "Invalid date",
	"Data Final": "Final Date",
	"Data é requerido": "Date is required",
	"Data final": "Final date",
	"Definir como padrão ao iniciar": "Set as default on startup",
	"Descrição é obrigatório": "Description is required",
	"Descrição é requerido": "Description is required",
	"Descrição completa": "Complete description",
	"Dashboard padrão": "Default dashboard",
	"Deletado com sucesso": "Successfully deleted",
	"Deseja ativar o modo manutenção": "Do you want to enable maintenance mode",
	"Deseja desativar o modo manutenção": "Do you want to disable maintenance mode",
	"Deseja realmente excluir": "Do you really want to delete",
	"Deseja realmente excluir o comentário": "Do you really want to delete the comment",
	"Deseja realmente excluir a FCA": "Do you really want to delete the FCA",
	"Deseja realmente excluir o histórico": "Do you really want to delete the history",
	"Deseja realmente salvar as alterações feitas": "Do you really want to save the changes made",
	"Desligar Zoom": "Turn off Zoom",
	"Desmarcar todos":"Unmark all",
	"Data de conclusão": "Conclusion date",
	"Data de exclusão": "Delete date",
	"Data é obrigatório": "Date is required",
	"data final":"final date",
	"Data Final tem que ser após a Data Inicial": "End Date must be after Start Date",
	"Data Final é requerida": "End Date required",
	"data inicial":"inicial date",
	"Data Inicial é requerida": "Start Date required",
	"Dados Gerais": "General data",
	"Data final não pode ser menor que a inicial":"End date can't be before initial date",
	"Data prevista": "Expected date",
	"Deletar permanente": "Permanent delete",
	"Definir como agrupador padrão": "Set as default grouper",
	"Deseja realmente deletar o item permanente": "Do you really want to delete the item permanent",
	"Deseja realmente restaurar o item": "Do you really want to restore the item",
	"Diagrama ishikawa": "Ishikawa diagram",
	"Diagnóstico de negócio": "Business diagnosis",
	"Diagnóstico de Negócio": " Business Diagnosis",
	"Dia Inteiro": "Hole Day",
	"Digite para filtrar as opções": "Type to filter the options",
	"Digite para filtrar ou criar as opções": "Type to filter or create options",
	"Duração é requerido": "Duration is required",
	"Empresa logada alterada com sucesso": "Company logged in successfully changed",
	"É necessário inserir um comentário": "You must enter a comment",
	"É necessario preencher ao menos um item de checklist": "You must complete at least one checklist item",
	"É necessário zerar os valores antes de excluí-lo": "Must reset values ​​to zero before deleting it",
	"Email diferente do permitido para esse link": "Email different than allowed for this link",
	"Em andamento": "In progress",
	"em andamento": "in progress",
	"Em Progresso": "In Progress",
	"Em Rascunho": "Draft",
	"em rascunho": "draft",
	"Email com instruções enviado com sucesso": "Email with instructions sent successfully",
	"Endereço IP não permitido": "IP address not allowed",
	"Erro ao buscar abrir relatórios": "Error opening reports",
	"Erro ao buscar as notificações. Atualize a página ou tente novamente mais tarde": "Error fetching notifications. Refresh the page or try again later",
	"Erro ao adicionar anexos": "Error adding attachments",
	"Erro ao alterar agrupador padrão": "Error changing default grouper",
	"Erro ao alterar andamento": "Error changing progress",
	"Erro ao alterar campo": "Error changing field",
	"Erro ao alterar histórico": "Error changing history",
	"Erro ao alterar permissões": "Error changing permissions",
	"Erro ao aprovar/rejeitar postergação": "Error approving/rejecting postponement",
	"Erro ao ativar/desativar modo manutenção": "Error activating/deactivating maintenance mode",
	"Erro ao atualizar ação, favor atualizar a pagina": "Error updating action, please refresh the page",
	"Erro ao atualizar indicador, favor atualizar a pagina": "Error updating indicator, please refresh the page",
	"Erro ao atualizar a ordenação": "Error updating ordering",
	"Erro ao buscar anexos": "Error fetching attachments",
	"Erro ao buscar cancelamento": "Error searching cancellation",
	"Erro ao buscar dados": "Error searching data",
	"Erro ao buscar histórico": "Error searching history",
	"Erro ao buscar itens":"Error on search itens",
	"Erro ao buscar comentários": "Error fetching comments",
	"Erro ao cancelar ação": "Error canceling action",
	"Erro ao carregar as permissões": "Error loading permissions",
	"Erro ao carregar os agrupadores": "Error loading groupers",
	"Error ao comunicar com o servidor": "Error to comunicate with server",
	"Erro ao deletar": "Error to delete",
	"Erro ao enviar email": "Error sending email",
	"Erro ao excluir comentário": "Error deleting comment",
	"Erro ao excluir FCA": "Error deleting FCA",
	"Erro ao excluir histórico": "Error deleting history",
	"Erro ao gerar item de norma":"Error on creating standard item",
	"Erro ao inserir cancelamento": "Error inserting cancelation request",
	"Erro ao inserir comentário": "Error inserting comment",
	"Erro ao inserir postergação": "Error inserting postponement",
	"Erro ao inserir/alterar FCA": "Error inserting/changing FCA",
	"Erro ao inserir permissões": "Error inserting permissions",
	"Erro ao listar FCA": "Error listing FCA",
	"Erro ao marcar notificação como lida": "Error marking notification as read",
	"Erro ao marcar notificação como não lida": "Error marking notification as unread",
	"Erro ao marcar todas notificações como lida": "Error marking all notification as read",
	"Erro ao salvar itens da norma":"Error on save standard item",
	"Erro ao tentar encontrar resultados para esta pesquisa": "Error trying to find results for this search",
	"Erro ao trocar de empresa": "Error switching company",
	"Erro ao trocar imagem do perfil": "Error changing profile image",
	"Erro ao reordenar FCA": "Error reordering FCA",
	"Erro ao reordenar": "Error reordering",
	"Erro ao restaurar faixas": "Error on restore ranges",
	"Erro de rede": "Network error",
	"Erro de tipo": "Type Error",
	"Esconder todos": "Hide all",
	"Este e-mail já possui uma conta na plataforma. Utilize o convite para registrá-lo a empresa": "This email already has an account on the platform. Use the invitation to register the company",
	"Esse link de remoção de autenticação em dois fatores é invalido": "This two-factor authentication removal link is invalid",
	"Esta é uma consequência das demais perspectivas. Atendendo bem os objetivos estratégicos das demais perspectivas, os objetivos financeiros devem ser alcançados.": "This is a consequence of the other perspectives. Given the strategic objectives of the other perspectives, the financial objectives must be achieved.",
	"Ex. usuários": "Ex. Users",
	"Excedida quantidade máxima definida no contrato": "Exceeded maximum quantity defined in the contract",
	"Excluído por": "Deleted by",
	"Excluir comentário": "Delete comment",
	"Excluir Faixa":"Delete range",
	"Excluir histórico": "Delete history",
	"Exclusão de autenticação em dois fatores": "Two factor authentication exclusion",
	"Exclusão de comentário": "Delete comment",
	"Exclusão de FCA": "Delete FCA",
	"Exclusão de histórico": "Delete history",
	"Exige eficácia": "Requires effectiveness",
	"Expandir próximos 3 agrupadores": "Expand next 3 groupers",
	"Expandir todos agrupadores": "Expand all groupers",
	"Expandir todos":"Expand all",
	"Exportar página atual": "Export current page",
	"Exportar todas páginas": "Export all pages",
	"Erro ao importar arquivo":"Error on import file",
	"Erro ao restaurar": "Error to restore",
	"Empilhado":"Stacked",
	"Fato é requerido": "Fact is required",
	"Fator crítico de sucesso": "Critical success factor",
	"Fechado": "Closed",
	"Fechar": "Close",
	"FCA - Indicador": "FCA - Indicator",
	"FCA excluída com sucesso": "FCA successfully deleted",
	"Fato e causa da Ocorrência": "Fact and cause of the Occurrence",
	"Fonte de dados":"Data source",
	"Gerar recorrência": "Generate recurrence",
	"Gerenciar metas": "Manage goals",
	"gráfico pizza": "pie chart",
	"Grau médio": "Medium degree",
	"Grupo empresa ou empresa está inativo": "Business group or company is inactive",
	"Grupo de usuários": "Users group",
	"Grupo de usuário": "User group",
	"Grupos de usuário": "User groups",
	"Grupos de usuários": "Users groups",
	"Grupo empresarial": "Business group",
	"Grupo de usuários não podem ser repetidos": "User group cannot be repeated",
	"Grupo de qualidade": "Quality group",
	"Hierarquia de Mapas": "Map Hierarchy",
	"Hierarquia de mapas": "Map hierarchy",
	"Hierarquia de permissões": "Permissions hierarchy",
	"Histórico alterado com sucesso": "History successfully changed",
	"Histórico excluído com sucesso": "History successfully deleted",
	"Imagem do perfil atualizada com sucesso": "Profile image updated successfully",
	"Indique e ganhe": "Refer and win",
	"Informe o valor da chave de acesso para prosseguir": "Enter the access key value to proceed",
	"Ir a tela de cadastro": "Go to registration screen",
	"Informados não podem ser repetidos": "Informeds cannot be repeated",
	"Inserir chave de acesso externo": "Enter external access key",
	"Itens salvos com sucesso": "Itens saved with success",
	"Itens da norma salvos com sucesso":"Standard items successfully saved",
	"Informar valores": "Inform values",
	"Ligar Zoom": "Turn on Zoom",
	"Lado a lado":"Side by side",
	"Limpar configurações": "Clean settings",
	"Limpar filtros": "Clear filters",
	"Limpar cor": "Clear color",
	"Últimos 7 dias":"Last 7 days",
	"Últimos 30 dias":"Last 30 days",
	"Mapa BSC": "BSC Map",
	"Mapas estratégicos": "Strategic maps",
	"Marcar todas como lidas": "Mark all as read",
	"Melhorando os processos internos iremos atender melhor os clientes.": "By improving internal processes, we will better serve customers.",
	"Marcar para atualizar": "Mark to update",
	"Marcar todos":"Mark all",
	"Métrica padrão":"Default metric",
	"Menu de permissões": "Permissions menu",
	"Meu perfil": "My profile",
	"Mês atual":"Actual month",
	"Mês de inicio": "Start month",
	"Mês passado":"Past month",
	"Método de avaliação":"Valuation method",
	"Modo escuro": "Dark mode",
	"Modo claro": "White mode",
	"Modo manutenção": "Maintenance mode",
	"modo manutenção": "maintenance mode",
	"Mostrar mais": "Show more",
	"Mostrar Orçamento": "Show Budget",
	"Mostrar todos": "Show all",
	"Motivo é requerido": "Reason is required",
	"Modelos de diagnóstico de negócio": "Business diagnostic models",
	"Não atingiu": "Didn't hit",
	"Não autorizado": "Unauthorized",
	"Não concluída": "Not completed",
	"Não foram encontrados comentários": "No comments found",
	"Não foram encontrados dados": "No data found",
	"Não iniciadas": "Not started",
	"não iniciadas": "not started",
	"não iniciada": "not started",
	"Não iniciados": "Not started",
	"Não há eventos nesse periodos":"There are no events in this period",
	"Não foram encontrados resultados para esta pesquisa" : "No results were found for this search",
	"Não lidas": "Unread",
	"Não, voltar ao valor anterior":"No, go back to previus value",
	"Não, alterar apenas a métrica padrão":"No, change only the default metric",
	"Não foi encontrado itens para esta norma":"No itens were found for this standard",
	"Não pode inserir na hierarquia com nome vazio": "Cannot insert into hierarchy with empty name",
	"Nova análise": "New analysis",
	"Nova(s) notificação(ões)": "New notification(s)",
	"Ponto e vírgula":"Semicolon",
	"Novo item":"New item",
	"Novo porquê": "New why",
	"Nome completo": "Full name",
	"Nome é requerido": "Name is required",
	"Não foram encontrados resultados para esta pesquisa, aperte para ir a tela de cadastro": "No results were found for this search, press to go to registration screen",
	"Não há nenhum histórico": "There is no history",
	"Não há nenhum histórico com anexos": "There is no history with attachments",
	"Não Iniciada": "Not Started",
	"Não iniciada": "Not started",
	"Não iniciado": "Not started",
	"não iniciado(s)": "not started(s)",
	"não iniciada(s)": "not started(s)",
	"Nenhum agrupador encontrado": "No wrappers found",
	"Nenhum Checklist adicionado": "No Checklist Added",
	"Número de unidades/filiais na Gestão Orçamentária": "Number of units/subsidiarys in Budget Management",
	"Objetivos x Indicadores": "Objectives x Indicators",
	"Ocorreu um erro": "An error has occurred",
	"Ordenação atualizada com sucesso": "Order updated successfully",
	"O sistema encontra-se em modo de manutenção": "The system is in maintenance mode",
	"Os clientes estando bem atendidos e satisfeitos teremos como consequência um maior retorno financeiro pois clientes satisfeitos compram mais.": "Customers being well serviced and satisfied will result in a greater financial return as satisfied customers buy more.",
	"Painel de Projetos": "Project Panel",
	"Painel de projetos": "Project panel",
	"Página Inicial": "Home page",
	"Página não encontrada": "Page not found",
	"Paleta de cores":"Colors palette",
	"Para acessá-la é necessario estar num plano contratual que a permite": "To access it, it is necessary to be on a contractual plan that allows it",
	"Para adicionar uma nova permissao na hierarquia de menu adicione-a ao JSON na pasta src/context/Auth/permissionsMenu.ts": "To add a new permission in the menu hierarchy, add it to the JSON in the folder src/context/Auth/permissionsMenu.ts",
	"Para ter acesso a aplicação, solicite acesso a um grupo empresa": "To gain access to the application, request access to a company group",
	"Próximo de expirar": "Next to expire",
	"Próximo mês":"Next month",
	"Percentual acumulado": "Accumulated percentage",
	"Percentual realizado": "Percentage accomplished",
	"Período anterior": "Previous period",
	"Permissão alterada com sucesso": "Permission successfully changed",
	"Permissões inseridas com sucesso": "Permissions successfully inserted",
	"Pesquisar menu": "Search menu",
	"Próximos 30 dias": "Next 30 days",
	"Preencha todos os campos para prosseguir": "Fill in all fields for",
	"Pessoas bem treinadas e capacitadas conseguem atender e realizar melhor os processos internos.": "Well-trained and capable people are able to better serve and carry out internal processes.",
	"Planejamento Estratégico": "Strategic Planning",
	"Por favor, tente novamente mais tarde": "Please try again later",
	"Por quê?": "Why",
	"Porquê é requerido": "Why is required",
	"Política de privacidade": "Privacy policy",
	"Processos Internos": "Internal processes",
	"Próximo período": "Next period",
	"Reordenação concluída com sucesso": "Reordering completed successfully",
	"Recolher todos":"Compress all",
	"Registros por página": "Records per page",
	"registro selecionado": "selected record",
	"registros selecionados": "selected records",
	"Responder comentário": "Answer comment",
	"Resposta é requerida": "Answer is required",
	"Restaurado com sucesso": "Successfully restored",
	"Restrição de horário": "Schedule restriction",
	"Restrição de horários": "Schedule restriction",
	"Resultados encontrados": "Results found",
	"Restaurar faixas":"Restore ranges",
	"Saia e faça login novamente ou se o erro persistir, entre em contato com seu administrador para ver se você tem acesso a este recurso": "Please Log Out and Log In again or if the error persists, contact your admin to see if you have access to this feature",
	"Salvar alterações": "Save changes",
	"Semana Inteira": "Hole week",
	"Sem Frequência": "No Frequency",
	"Sem valor": "Without value",
	"Será enviado um email com instruções para remover o dispositivo cadastrado com a autenticação em dois fatores. Deseja prosseguir": "An email will be sent with instructions to remove the device enrolled with two-factor authentication. Do you want to proceed",
	"Sessão inválida": "Invalid session",
	"Sim, alterar todas as faixas":"Yes, change all ranges",
	"Sistema em modo manutenção": "System in maintenance mode",
	"Selecionar Opção": "Select option",
	"Selecione um grupo de usuário ou usuário para gerenciar as permissões": "Select a user group or user to manage permissions",
	"Itens da norma":"Standard itens",
	"Seleção de itens da norma":"Standard itens selection",
	"Sem acesso": "Without access",
	"Sem origem": "Without origin",
	"setor": "sector",
	"Setor:": "Sector:",
	"Suas Ações": "Your Actions",
	"Tela cheia": "Full screen",
	"Termos de uso": "Terms of use",
	"Texto copiado": "Copied text",
	"Título é requerido": "Title is required",
	"Títulos não podem ser repetidos": "Titles cannot be repeated",
	"Tipo de período":"Period type",
	"Trocar empresa": "Change company",
	"Usuários não podem ser repetidos": "Users cannot be repeated",
	"Ultimo valor":"Last value",
	"Utilize as permissões para informar quais usuários, ou grupos de usuários, terão acesso ou permissão para editar": "Use permissions to tell which users, or groups of users, will have access or permission to edit",
	"Unidade de medida":"Measure unit",
	"Validade é requerida": "Validity is required",
	"Valor é requerido": "Value is required",
	"Valor absoluto":"Absolute value",
	"Valor Monetário": "Monetary Value",
	"Valor acumulado": "Accumulated value",
	"Valor do Check In": "Check In value",
	"Valor inicial": "Initial value",
	"Valor Inicial": "Initial Value",
	"Valor inicial está incorreto":"Initial value is incorrect",
	"Valor inicial a faixa é requerida":"Range's initial value is required",
	"Valor final está incorreto":"Final value is incorrect",
	"Valor final a faixa é requerida":"Range's Final value is required",
	"Valor realizado": "Realized value",
	"Valores anuais": "Annual values",
	"Valores da FCA inseridos/alterados com sucesso": "FCA values ​​successfully inserted/changed",
	"Valores mensais": "Monthly values",
	"Ver todas": "See all",
	"Verifique os campos e tente novamente": "Check the fields and try again",
	"Verifique os erros no formulário e tente novamente": "Check the form for errors and try again",
	"Verifique se você possui acesso": "Make sure you have access",
	"Visualizar gráfico": "Visualize chart",
	"Você ativou o modo manutenção": "You have activated maintenance mode",
	"Você desativou o modo manuntenção": "You have deactivated maintenance mode",
	"Você está tentando alterar a posição de uma FCA não salva": "You are trying to change the position of an unsaved FCA",
	"Você não tem acesso a este recurso ou suas credenciais de login expiraram": "You don't have access to this feature or your login credentials has expired",
	"Voltar ao início": "Back to start",
	"Você pode restaurar/verificar os itens excluidos na tela da lixeira": "You can restore/verify deleted items in recycle bin screen",
	"Você não pode fazer upload de imagens com tamanho maior que 150 kB": "You cannot upload images larger than 150 kB",
	"Você não tem acesso ao grupo empresa {{businessGroupName}} nesse horário": "You do not have access to the business group {{businessGroupName}} at this time",
	"Você não tem acesso a nenhum grupo empresa": "You do not have access to any business groups",
	"Você não tem acesso a página requisitada": "You do not have access to the page requested",
	"Você só pode fazer uploads de arquivos jpg, jpeg ou png": "You can only upload jpg, jpeg or png files",
	"Você tem nova(s) notificação(ões)": "You have new notification(s)",
	"Mostrar valor":"Show value",
	"código do período":"period code", 	
	"Visualiza e analisa":"View and analyze",
	"Visualiza e altera valores":"View and change values",
	"Visualiza e altera meta e valores":"View and change goal and values",
	"Mostrar +{{total}}":"Show +{{total}}"
};

export default ENPhrases;
